import type { LabelOverlay, LabelStyle, TelopFont } from '@shared/types'
import { useEditorStore } from '../../../../store/editorStore'
import { SelectField, TextField } from '../../../common/Field'
import { InspectorFrame } from './InspectorFrame'
import { OVERLAY_KIND_LABEL } from '../overlayMeta'
import { FONT_SELECT_LABEL, FONT_SELECT_ORDER } from './fontOptions'

const STYLE_LABEL: Record<LabelStyle, string> = {
  bracket: '【角括弧】',
  quote: '「鍵カッコ」',
  plain: '飾りなし',
  breedNagoya: '品種図鑑(名古屋・和名+英名)',
  breedGinza: '品種図鑑(銀座・和名+ふりがな)',
}

/** 旧 TabLabels.tsx の 1 行分の編集フィールドを選択駆動インスペクタへ切り出したもの。 */
export function LabelInspector({ overlay }: { overlay: LabelOverlay }) {
  const updateOverlay = useEditorStore((s) => s.updateOverlay)
  function patch(p: Partial<LabelOverlay>) {
    updateOverlay(overlay.id, p)
  }

  return (
    <InspectorFrame
      title={OVERLAY_KIND_LABEL.label}
      overlayId={overlay.id}
      overlayKind="label"
      startSec={overlay.startSec}
      durationSec={overlay.durationSec}
      minDurationSec={0.3}
      maxDurationSec={8}
    >
      <TextField label="和名" value={overlay.ja} onChange={(e) => patch({ ja: e.target.value })} />
      <TextField label="英名 / ふりがな" value={overlay.en ?? ''} onChange={(e) => patch({ en: e.target.value })} />
      <SelectField label="書式" value={overlay.style} onChange={(e) => patch({ style: e.target.value as LabelStyle })}>
        {(Object.keys(STYLE_LABEL) as LabelStyle[]).map((s) => (
          <option key={s} value={s}>
            {STYLE_LABEL[s]}
          </option>
        ))}
      </SelectField>
      <SelectField
        label="位置"
        value={overlay.position}
        onChange={(e) => patch({ position: e.target.value as LabelOverlay['position'] })}
      >
        <option value="left-upper">左上</option>
        <option value="left-lower">左下</option>
        <option value="bottom">下中央</option>
      </SelectField>
      {/* P10-1: 未定義は「ゴシック」として表示。 */}
      <SelectField
        label="フォント"
        value={overlay.font ?? 'gothic'}
        onChange={(e) => patch({ font: e.target.value as TelopFont })}
        data-testid="overlay-font-select"
      >
        {FONT_SELECT_ORDER.map((f) => (
          <option key={f} value={f}>
            {FONT_SELECT_LABEL[f]}
          </option>
        ))}
      </SelectField>
    </InspectorFrame>
  )
}
